import React, {useState, useEffect} from 'react'
import Button from './Button';
import PicCont from './PicCont';
import { AiOutlineArrowRight } from '@react-icons/all-files/ai/AiOutlineArrowRight';
import { AiOutlineArrowLeft } from '@react-icons/all-files/ai/AiOutlineArrowLeft';
import { GiBinoculars } from '@react-icons/all-files/gi/GiBinoculars';
import { FaChartLine } from '@react-icons/all-files/fa/FaChartLine';
import { FaChartBar } from '@react-icons/all-files/fa/FaChartBar';
import { useRouter } from 'next/dist/client/router';
import unit from '../public/Pictures/24-hours.png'
import { helper } from '../utilities/helper';


const SalesMetrics = ({potential, setStep, metrics}) => {
  let {push} = useRouter()
  let [part, setPart] = useState(0)

  useEffect(() => {
    if(potential && potential?.business_type !== 'venue') setPart(2)
  }, [potential])

  let metric = metrics[potential?.sub_type]?.[potential?.metrics?.venue_size]

  console.log(metric)

  let per_cost = (potential?.metrics?.event_cost / metric?.event_cost)*100
  let per_av = (potential?.metrics?.av_cost / metric?.av_cost)*100
  let monthly_rev = potential?.metrics?.event_cost * potential?.metrics?.events_week * 4
  let monthly_av = potential?.metrics?.av_cost * potential?.metrics?.events_week * 4
  let metrics_rev = metric?.event_cost * metric?.events_week * 4
  let per_rev = (monthly_rev / metrics_rev)*100
  let tier =monthly_av > 30000 ? 3: monthly_av > 10000 ? 2: 1
  return <div className='sSlide'>
   {potential?.business_type === 'venue' && <div className='compCard'>
        <div className='cardTitle'>
       <GiBinoculars />
        <strong>AV Observatory</strong>
        <span>Industry Standards for {metric?.definition}</span>
          </div>
          <div className='metric'>
            <strong>{metric?.events_week}</strong>
            <span className='metricSub'>Events per Week</span>
          </div>
          <div className='metric'>
            <strong>{helper.formatPrice(metric?.event_cost, true)}</strong>
            <span className='metricSub'>Average Event Cost</span>
          </div>
          <div className='metric'>
          <strong>{helper.formatPrice(metric?.av_cost, true)}</strong>
            <span className='metricSub'>AV Average cost</span>
          </div>
          <div className='metric'>
          <strong>{helper.formatPrice(metrics_rev, true)}</strong>
            <span className='metricSub'>Monthly Revenue from Events</span>
          </div>

      </div>}

   {part > 0 && potential?.business_type === 'venue' && <div className='compCard'>
        <div className='cardTitle blue'>
        <FaChartLine />
        <strong>GROWTH POTENTIAL</strong>

          </div>
          <div className='metric'>
            <strong>{potential?.metrics?.events_week}</strong>
            <span className='metricSub'>Events per Week</span>
          </div>
          <div className='metric'>
          <strong>{helper.formatPrice(potential?.metrics?.event_cost, true)}</strong>
            <span className='metricSub'>Average Event Cost</span>
            <span  className={per_cost > 100 ? 'metricPer green' :'metricPer red'}>{per_cost.toFixed(0)}%</span>
          </div>
          <div className='metric'>
          <strong>{helper.formatPrice(potential?.metrics?.av_cost, true)}</strong>
            <span className='metricSub'>AV Average cost</span>
            <span className={per_av > 100 ? 'metricPer green' :'metricPer red'}>{per_av.toFixed(0)}%</span>
          </div>
          <div className='metric'>
          <strong>{helper.formatPrice(monthly_rev, true)}</strong>
            <span className='metricSub'>Monthly Revenue from Events</span>
            <span className={per_av > 100 ? 'metricPer green' :'metricPer red'}>{per_rev.toFixed(0)}%</span>
          </div>

      </div>}
   {part >1 && <div className='compCard black'>
      <div className='backBlack'></div>
        <div className='cardTitle'>
        <FaChartBar/>
        <strong>PROJECTIONS</strong>

          </div>
          <div className='metric'>
            <strong>Tier {tier}</strong>
            <span className='metricSub'>Based on your {helper.formatPrice(monthly_av, true)} monthly AV</span>
          </div>
          <div className='metric'>
            <strong>{tier *10}%</strong>
            <span className='metricSub'>{potential?.model?.two ? 'Commission': 'Discount'}</span>
          </div>
          <div className='metric'>
            <strong>{helper.formatPrice((monthly_av || (metric?.av_cost * potential?.metrics?.events_week * 4))*(tier/10), true)}</strong>
            <span className='metricSub'>Projected Monthly {potential?.model?.two ? 'Commission': 'Savings'}</span>
          </div>

      </div>}



      <div className='buttons'>
      <Button className='btn-5  ' onClick={() => setStep(0)} ><AiOutlineArrowLeft />Back</Button>
        <Button className='btn-5  highLight' onClick={() => part < 2 ? setPart(p => p+1) : push(`/partnerships?id=${potential?._id}&sign=true`)} ><AiOutlineArrowRight />Continue</Button>
    </div>
  </div>
}

export default SalesMetrics